export default "__VITE_ASSET__CGOnshfz__"